import { Box } from "@mui/material";
import { JSX } from "react";
import { Typography } from "@platform/design-system";

export const msgs = [
  {
    title: "Pending Assignment",
    subtitle: "RFP was received - pending Centro analyst assignment",
  },
  {
    title: "Under Review",
    subtitle: "Your Centro analyst is reviewing all submitted RFP information",
  },
  {
    title: "Out to Market",
    subtitle:
      "RFP was submitted to carriers and proposals are being reviewed by Centro",
  },
  {
    title: "Delivered Partial",
    subtitle: "Marketing presentation delivered - pending carrier updates",
  },
  {
    title: "Delivered Final",
    subtitle: "Marketing presentation complete - no outstanding items",
  },
  { title: "Complete", subtitle: "Client decision confirmed" },
  {
    title: "Withdrawn",
    subtitle: "Centro received a request to withdraw this RFP from marketing",
  },
];

const RFPStatusTooltipTitle = (): JSX.Element => (
  <Box>
    {msgs.map((item) => (
      <Typography
        key={item.title}
        variant="caption"
        component="p"
        color="inherit"
      >
        <Typography
          variant="caption"
          component="span"
          color="inherit"
          display="inline-block"
        >
          <strong>{item.title}</strong>
        </Typography>
        : {item.subtitle}
      </Typography>
    ))}
  </Box>
);

export default RFPStatusTooltipTitle;
